import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const ContentDedupePage = withSuspense(lazy(() => import('./content-dedupe.page')));
export default ContentDedupePage;
